import React from "react";
import { FiAlertCircle, FiRefreshCw } from "react-icons/fi";

interface ErrorStateProps {
  error: Error | string;
  title?: string;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  error,
  title = "Error",
  onRetry,
}) => {
  const errorMessage = error instanceof Error ? error.message : error;

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-8 mt-20 w-full max-w-3xl mx-auto">
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-6 w-full">
        <div className="flex items-center">
          <FiAlertCircle className="text-red-600 dark:text-red-400 text-2xl mr-3" />
          <h3 className="text-lg font-semibold text-red-800 dark:text-red-200">
            {title}
          </h3>
        </div>
        <p className="mt-3 text-red-700 dark:text-red-300">{errorMessage}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-red-700 dark:text-red-200 hover:bg-red-100 dark:hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <FiRefreshCw className="mr-2" />
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;
